// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root .rc__2bcw1j {
    --rc-footer-bgColor: #1f2431;
    --rc-footer-color: #afb6c9;
    --rc-footer-hover-color: #62687f;
    --rc-footer-active-color: #8d96b2;
    --rc-footer-bottom-bgColor: #343b4c;
    --rc-footer-bottom-color: #afb6c9;
    --rc-footer-social-color: #c6cad8;
    --rc-footer-social-bgColor: #343b4c;
    --rc-footer-social-hover-bgColor: #62687f;
    --rc-footer-social-active-bgColor: #8d96b2;
    --rc-footer-age-border: 1px solid #afb6c9;
    --rc-footer-age-bgColor: transparent;
  }
  :root .rc__3rex23 {
    --rc-footer-bgColor: #ffffff;
    --rc-footer-color: #777e98;
    --rc-footer-hover-color: #2c54e2;
    --rc-footer-active-color: #274bc8;
    --rc-footer-bottom-bgColor: #f3f4f7;
    --rc-footer-bottom-color: #8d96b2;
    --rc-footer-social-color: #4a7dfd;
    --rc-footer-social-bgColor: #e0ebff;
    --rc-footer-social-hover-bgColor: #c1d8ff;
    --rc-footer-social-active-bgColor: #a2c4ff;
    --rc-footer-age-border: 0;
    --rc-footer-age-bgColor: #f3f4f7;
  }

.rc__338153 {
  display: block;
  width: 100%;
  min-width: 320px;
  background-color: var(--rc-footer-bgColor);
}

.rc__2mtpsb {
  margin-left: auto;
  margin-right: auto;
}

@media (min-width: 1300px) {

.rc__2mtpsb {
    width: 1260px;
    padding-left: 0;
    padding-right: 0
}
  }

.rc__4ehxwr {
  display: flex;
  padding: 20px;
}

@media (max-width: 768px) {

.rc__4ehxwr {
    flex-direction: column;
    align-items: center;
    row-gap: 25px;
    padding-bottom: 25px
}
  }

@media (min-width: 769px) and (max-width: 1299px) {

.rc__4ehxwr {
    flex-direction: column;
    align-items: center;
    row-gap: 20px
}
  }

@media (min-width: 1300px) {

.rc__4ehxwr {
    align-items: flex-start;
    -moz-column-gap: 20px;
         column-gap: 20px
}
  }

.rc__3sqr4w {
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
  -moz-column-gap: 20px;
       column-gap: 20px;
  padding: 0;
  margin: 0;
  list-style: none;
}

@media (max-width: 768px) {

.rc__3sqr4w {
    justify-content: center;
    row-gap: 20px;
    order: 2
}
  }

@media (min-width: 769px) {

.rc__3sqr4w {
    row-gap: 10px
}
  }

.rc__2fs6dp:first-child {
    width: 100%;
  }

@media (max-width: 768px) {

.rc__2fs6dp {
    text-align: center
}
  }

.rc__2gvh6h {
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 20px;
  color: var(--rc-footer-color);
}

@media (hover: hover) {

button.rc__2gvh6h,
a.rc__2gvh6h {
    transition: color 200ms
}

    button.rc__2gvh6h:hover, a.rc__2gvh6h:hover {
      color: var(--rc-footer-hover-color);
    }
  }

button.rc__2gvh6h:active, a.rc__2gvh6h:active {
    color: var(--rc-footer-active-color);
  }

button.rc__2gvh6h {
  padding: 0;
  border: 0;
  background-color: transparent;
  box-shadow: none;
  cursor: pointer;
}

a.rc__2gvh6h {
  -webkit-text-decoration: none;
  text-decoration: none;
}

.rc__36ejjt {
  display: flex;
}

@media (max-width: 768px) {

.rc__36ejjt {
    justify-content: center;
    -moz-column-gap: 20px;
         column-gap: 20px;
    order: 1
}
  }

@media (min-width: 769px) and (max-width: 1299px) {

.rc__36ejjt {
    justify-content: space-between;
    width: 100%
}
  }

@media (min-width: 1300px) {

.rc__36ejjt {
    -moz-column-gap: 10px;
         column-gap: 10px
}
  }

@media (min-width: 769px) and (max-width: 1299px) {

.rc__5zx36g {
    flex-grow: 1
}
  }

.rc__87nnm1 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  font-family: "Manrope", sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  color: var(--rc-footer-color);
  border-radius: 20px;
  border: var(--rc-footer-age-border);
  background-color: var(--rc-footer-age-bgColor);
}

.rc__32gy5f {
  display: flex;
}

@media (max-width: 768px) {

.rc__32gy5f {
    -moz-column-gap: 20px;
         column-gap: 20px
}
  }

@media (min-width: 769px) {

.rc__32gy5f {
    -moz-column-gap: 10px;
         column-gap: 10px
}
  }

.rc__8q84js {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  font-size: 0;
  border-radius: 20px;
  -webkit-text-decoration: none;
  text-decoration: none;
  background-color: var(--rc-footer-social-bgColor);
}

@media (hover: hover) {

.rc__8q84js {
    transition: background-color 200ms
}

    .rc__8q84js:hover {
      background-color: var(--rc-footer-social-hover-bgColor);
    }
  }

.rc__8q84js:active {
    background-color: var(--rc-footer-social-active-bgColor);
  }

.rc__3ngnyh {
  display: block;
  width: 20px;
  height: 20px;
  color: var(--rc-footer-social-color);
}

.rc__3zhfy8 {
  background-color: var(--rc-footer-bottom-bgColor);
}

.rc__5te5mx {
  display: flex;
}

@media (max-width: 768px) {

.rc__5te5mx {
    flex-direction: column
}
  }

@media (min-width: 769px) {

.rc__5te5mx {
    justify-content: space-between;
    align-items: center
}
  }

.rc__6995vq {
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: 5px 20px;
}

@media (max-width: 768px) {

.rc__6995vq {
    width: 100%;
    justify-content: center
}

    .rc__6995vq + .rc__6995vq {
      border-top: solid 1px var(--rc-footer-bgColor);
    }
  }

.rc__4b373h {
  font-family: "Manrope", sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  color: var(--rc-footer-color);
}

@media (max-width: 768px) {

.rc__4b373h {
    text-align: center
}
  }

.rc__4b373h a {
    color: var(--rc-footer-color);
    -webkit-text-decoration: none;
    text-decoration: none;
  }

@media (hover: hover) {

.rc__4b373h a {
      transition: color 200ms
  }

      .rc__4b373h a:hover {
        color: var(--rc-footer-hover-color);
      }
    }

.rc__4b373h a:active {
      color: var(--rc-footer-active-color);
    }

.rc__7g8jjc {
  margin-right: 10px;
  font-family: "Manrope", sans-serif;
  font-size: 13px;
  line-height: 20px;
  font-weight: 500;
  color: var(--rc-footer-bottom-color);
  white-space: nowrap;
}

.rc__4dykab {
  display: flex;
  align-items: center;
  color: var(--rc-footer-color);
}

`, "",{"version":3,"sources":["webpack://./node_modules/@rambler-components/footer/styles.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,0BAA0B;IAC1B,gCAAgC;IAChC,iCAAiC;IACjC,mCAAmC;IACnC,iCAAiC;IACjC,iCAAiC;IACjC,mCAAmC;IACnC,yCAAyC;IACzC,0CAA0C;IAC1C,yCAAyC;IACzC,oCAAoC;EACtC;EACA;IACE,4BAA4B;IAC5B,0BAA0B;IAC1B,gCAAgC;IAChC,iCAAiC;IACjC,mCAAmC;IACnC,iCAAiC;IACjC,iCAAiC;IACjC,mCAAmC;IACnC,yCAAyC;IACzC,0CAA0C;IAC1C,yBAAyB;IACzB,gCAAgC;EAClC;;AAEF;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;AAEA;IACI,aAAa;IACb,eAAe;IACf;AACJ;EACE;;AAEF;EACE,aAAa;EACb,aAAa;AACf;;AAEA;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb;AACJ;EACE;;AAEF;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;EACE;;AAEF;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;SAChB;AACT;EACE;;AAEF;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,qBAAqB;OAChB,gBAAgB;EACrB,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb;AACJ;EACE;;AAEF;;AAEA;IACI;AACJ;EACE;;AAEF;IACI,WAAW;EACb;;AAEF;;AAEA;IACI;AACJ;EACE;;AAEF;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;AAEA;;IAEI;AACJ;;IAEI;MACE,mCAAmC;IACrC;EACF;;AAEF;IACI,oCAAoC;EACtC;;AAEF;EACE,UAAU;EACV,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;SAChB,gBAAgB;IACrB;AACJ;EACE;;AAEF;;AAEA;IACI,8BAA8B;IAC9B;AACJ;EACE;;AAEF;;AAEA;IACI,qBAAqB;SAChB;AACT;EACE;;AAEF;;AAEA;IACI;AACJ;EACE;;AAEF;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;EACnB,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;;AAEA;IACI,qBAAqB;SAChB;AACT;EACE;;AAEF;;AAEA;IACI,qBAAqB;SAChB;AACT;EACE;;AAEF;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;;AAEA;IACI;AACJ;;IAEI;MACE,uDAAuD;IACzD;EACF;;AAEF;IACI,wDAAwD;EAC1D;;AAEF;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,aAAa;AACf;;AAEA;;AAEA;IACI;AACJ;EACE;;AAEF;;AAEA;IACI,8BAA8B;IAC9B;AACJ;EACE;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;AAEA;IACI,WAAW;IACX;AACJ;;IAEI;MACE,8CAA8C;IAChD;EACF;;AAEF;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;AAEA;IACI;AACJ;EACE;;AAEF;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,qBAAqB;EACvB;;AAEF;;AAEA;MACM;EACJ;;MAEI;QACE,mCAAmC;MACrC;IACF;;AAEJ;MACM,oCAAoC;IACtC;;AAEJ;EACE,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B","sourcesContent":[":root .rc__2bcw1j {\n    --rc-footer-bgColor: #1f2431;\n    --rc-footer-color: #afb6c9;\n    --rc-footer-hover-color: #62687f;\n    --rc-footer-active-color: #8d96b2;\n    --rc-footer-bottom-bgColor: #343b4c;\n    --rc-footer-bottom-color: #afb6c9;\n    --rc-footer-social-color: #c6cad8;\n    --rc-footer-social-bgColor: #343b4c;\n    --rc-footer-social-hover-bgColor: #62687f;\n    --rc-footer-social-active-bgColor: #8d96b2;\n    --rc-footer-age-border: 1px solid #afb6c9;\n    --rc-footer-age-bgColor: transparent;\n  }\n  :root .rc__3rex23 {\n    --rc-footer-bgColor: #ffffff;\n    --rc-footer-color: #777e98;\n    --rc-footer-hover-color: #2c54e2;\n    --rc-footer-active-color: #274bc8;\n    --rc-footer-bottom-bgColor: #f3f4f7;\n    --rc-footer-bottom-color: #8d96b2;\n    --rc-footer-social-color: #4a7dfd;\n    --rc-footer-social-bgColor: #e0ebff;\n    --rc-footer-social-hover-bgColor: #c1d8ff;\n    --rc-footer-social-active-bgColor: #a2c4ff;\n    --rc-footer-age-border: 0;\n    --rc-footer-age-bgColor: #f3f4f7;\n  }\n\n.rc__338153 {\n  display: block;\n  width: 100%;\n  min-width: 320px;\n  background-color: var(--rc-footer-bgColor);\n}\n\n.rc__2mtpsb {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n@media (min-width: 1300px) {\n\n.rc__2mtpsb {\n    width: 1260px;\n    padding-left: 0;\n    padding-right: 0\n}\n  }\n\n.rc__4ehxwr {\n  display: flex;\n  padding: 20px;\n}\n\n@media (max-width: 768px) {\n\n.rc__4ehxwr {\n    flex-direction: column;\n    align-items: center;\n    row-gap: 25px;\n    padding-bottom: 25px\n}\n  }\n\n@media (min-width: 769px) and (max-width: 1299px) {\n\n.rc__4ehxwr {\n    flex-direction: column;\n    align-items: center;\n    row-gap: 20px\n}\n  }\n\n@media (min-width: 1300px) {\n\n.rc__4ehxwr {\n    align-items: flex-start;\n    -moz-column-gap: 20px;\n         column-gap: 20px\n}\n  }\n\n.rc__3sqr4w {\n  display: flex;\n  flex-wrap: wrap;\n  flex-grow: 1;\n  -moz-column-gap: 20px;\n       column-gap: 20px;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\n@media (max-width: 768px) {\n\n.rc__3sqr4w {\n    justify-content: center;\n    row-gap: 20px;\n    order: 2\n}\n  }\n\n@media (min-width: 769px) {\n\n.rc__3sqr4w {\n    row-gap: 10px\n}\n  }\n\n.rc__2fs6dp:first-child {\n    width: 100%;\n  }\n\n@media (max-width: 768px) {\n\n.rc__2fs6dp {\n    text-align: center\n}\n  }\n\n.rc__2gvh6h {\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 20px;\n  color: var(--rc-footer-color);\n}\n\n@media (hover: hover) {\n\nbutton.rc__2gvh6h,\na.rc__2gvh6h {\n    transition: color 200ms\n}\n\n    button.rc__2gvh6h:hover, a.rc__2gvh6h:hover {\n      color: var(--rc-footer-hover-color);\n    }\n  }\n\nbutton.rc__2gvh6h:active, a.rc__2gvh6h:active {\n    color: var(--rc-footer-active-color);\n  }\n\nbutton.rc__2gvh6h {\n  padding: 0;\n  border: 0;\n  background-color: transparent;\n  box-shadow: none;\n  cursor: pointer;\n}\n\na.rc__2gvh6h {\n  -webkit-text-decoration: none;\n  text-decoration: none;\n}\n\n.rc__36ejjt {\n  display: flex;\n}\n\n@media (max-width: 768px) {\n\n.rc__36ejjt {\n    justify-content: center;\n    -moz-column-gap: 20px;\n         column-gap: 20px;\n    order: 1\n}\n  }\n\n@media (min-width: 769px) and (max-width: 1299px) {\n\n.rc__36ejjt {\n    justify-content: space-between;\n    width: 100%\n}\n  }\n\n@media (min-width: 1300px) {\n\n.rc__36ejjt {\n    -moz-column-gap: 10px;\n         column-gap: 10px\n}\n  }\n\n@media (min-width: 769px) and (max-width: 1299px) {\n\n.rc__5zx36g {\n    flex-grow: 1\n}\n  }\n\n.rc__87nnm1 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 20px;\n  color: var(--rc-footer-color);\n  border-radius: 20px;\n  border: var(--rc-footer-age-border);\n  background-color: var(--rc-footer-age-bgColor);\n}\n\n.rc__32gy5f {\n  display: flex;\n}\n\n@media (max-width: 768px) {\n\n.rc__32gy5f {\n    -moz-column-gap: 20px;\n         column-gap: 20px\n}\n  }\n\n@media (min-width: 769px) {\n\n.rc__32gy5f {\n    -moz-column-gap: 10px;\n         column-gap: 10px\n}\n  }\n\n.rc__8q84js {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 40px;\n  font-size: 0;\n  border-radius: 20px;\n  -webkit-text-decoration: none;\n  text-decoration: none;\n  background-color: var(--rc-footer-social-bgColor);\n}\n\n@media (hover: hover) {\n\n.rc__8q84js {\n    transition: background-color 200ms\n}\n\n    .rc__8q84js:hover {\n      background-color: var(--rc-footer-social-hover-bgColor);\n    }\n  }\n\n.rc__8q84js:active {\n    background-color: var(--rc-footer-social-active-bgColor);\n  }\n\n.rc__3ngnyh {\n  display: block;\n  width: 20px;\n  height: 20px;\n  color: var(--rc-footer-social-color);\n}\n\n.rc__3zhfy8 {\n  background-color: var(--rc-footer-bottom-bgColor);\n}\n\n.rc__5te5mx {\n  display: flex;\n}\n\n@media (max-width: 768px) {\n\n.rc__5te5mx {\n    flex-direction: column\n}\n  }\n\n@media (min-width: 769px) {\n\n.rc__5te5mx {\n    justify-content: space-between;\n    align-items: center\n}\n  }\n\n.rc__6995vq {\n  display: flex;\n  align-items: center;\n  min-height: 40px;\n  padding: 5px 20px;\n}\n\n@media (max-width: 768px) {\n\n.rc__6995vq {\n    width: 100%;\n    justify-content: center\n}\n\n    .rc__6995vq + .rc__6995vq {\n      border-top: solid 1px var(--rc-footer-bgColor);\n    }\n  }\n\n.rc__4b373h {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 20px;\n  color: var(--rc-footer-color);\n}\n\n@media (max-width: 768px) {\n\n.rc__4b373h {\n    text-align: center\n}\n  }\n\n.rc__4b373h a {\n    color: var(--rc-footer-color);\n    -webkit-text-decoration: none;\n    text-decoration: none;\n  }\n\n@media (hover: hover) {\n\n.rc__4b373h a {\n      transition: color 200ms\n  }\n\n      .rc__4b373h a:hover {\n        color: var(--rc-footer-hover-color);\n      }\n    }\n\n.rc__4b373h a:active {\n      color: var(--rc-footer-active-color);\n    }\n\n.rc__7g8jjc {\n  margin-right: 10px;\n  font-family: \"Manrope\", sans-serif;\n  font-size: 13px;\n  line-height: 20px;\n  font-weight: 500;\n  color: var(--rc-footer-bottom-color);\n  white-space: nowrap;\n}\n\n.rc__4dykab {\n  display: flex;\n  align-items: center;\n  color: var(--rc-footer-color);\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
